export default {
    name: "ProjectStatusChartWidget",
    type: "ChartWidget",
    description: "Visualizes the status of all your video projects.",
    roles: ["appUser"],
    widget: {
        title: "Project Status Overview",
        size: "medium",
        dataProvider: {
            main: {
                rpc: "VideoProjectRpc.getProjectStats",
                // Returns { labels: [], data: [], colors: [] }
                // ChartWidget expects an array of objects for 'main', so we need to transform it
                // OR ChartWidget needs to handle this format. 
                // Let's transform it into an array of objects for the ChartWidget to consume easily.
                transform: (response) => {
                    return response.labels.map((label, index) => ({
                        status: label,
                        count: response.data[index],
                        color: response.colors[index]
                    }));
                }
            }
        },
        chartType: "doughnut",
        labelsField: "status",
        dataField: "count",
        datasetOptions: {
            label: "Projects",
            backgroundColor: (context) => {
                // Chart.js context access to data
                const data = context.chart.data;
                if (data && data.datasets && data.datasets[0].data) {
                     // We need to map the colors from our data source
                     // This is tricky with the generic ChartWidget. 
                     // Simplified: We will rely on the default colors or pass the array if ChartWidget supports it.
                     // For now, let's use a static palette in options or let Chart.js handle it.
                     return [
                        '#6c757d', '#0dcaf0', '#ffc107', '#0d6efd', 
                        '#6610f2', '#fd7e14', '#198754', '#dc3545'
                     ];
                }
            }
        },
        options: {
            plugins: {
                legend: { position: 'right' }
            }
        }
    }
};